define('home/views/ForumCountCardView',[
    'backbone-marionette',

    'core/mixins/withChannelFollowing',
    'home/templates/forumCountCard',
], function (
    Marionette,

    withChannelFollowing,
    forumCountCardTemplate
) {
    'use strict';

    /**
     * A card that shows a forum or channel. Shows the avatar, title, description, stats
     * following status, and follow action.
     *
     * Expects a forum model.
     */
    var ExploreChannelCardView = Marionette.ItemView.extend({
        className: 'card',
        template: forumCountCardTemplate,

        templateHelpers: function () {
            var channel = this.model.channel;
            var primaryForum = channel.primaryForum;
            var numThreads = primaryForum.get('numThreads');
            var numFollowers = primaryForum.get('numFollowers');

            return {
                // Attributes may be null during fetch
                numThreads: numThreads && numThreads.toLocaleString(),
                numFollowers: numFollowers && numFollowers.toLocaleString(),
                channelDescription: channel && channel.get('options').description,
                channel: channel && channel.toJSON(),
            };
        },

        initialize: function () {
            this.bindToPrimaryForum();
        },

        // TODO: Clean duplication with this & withChannelFollowing
        bindToPrimaryForum: function () {
            var channel = this.model.channel;

            if (!channel.primaryForum) {
                this.listenToOnce(channel, 'changeRelated:primaryForum', this.bindToPrimaryForum);
                return;
            }

            // When a change is found, only update the counts so the button animates
            this.listenTo(channel.primaryForum,
                'change:numFollowers change:numThreads',
                this.renderStats);
        },

        renderStats: function () {
            this.$('[data-role=discussion-count]').text(this.model.get('numThreads').toLocaleString());
            this.$('[data-role=followers-count]').text(this.model.get('numFollowers').toLocaleString());
        },
    });

    withChannelFollowing.call(ExploreChannelCardView.prototype, function () {
        return this.model.channel;
    });

    return ExploreChannelCardView;
});

